import { render, staticRenderFns } from "./MdTableClaimBatchDetail.vue?vue&type=template&id=4804da85&"
import script from "./MdTableClaimBatchDetail.vue?vue&type=script&lang=js&"
export * from "./MdTableClaimBatchDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports